import * as Sentry from '@sentry/browser';

(() => {
  if (process.env.REACT_APP_ENVIRONMENT === 'local') {
    return;
  }
  Sentry.init({
    environment: process.env.REACT_APP_ENVIRONMENT,
    release: process.env.REACT_APP_DOCKER_TAG,
    dsn: 'https://5093681d08284df4baa717a2f86d58fc@sentry.io/1873459'
  });
})();
